import React, { useState } from "react";
import { Button } from "../../../components/Button";
import CommonGrid from "../../../components/CommonGrid";
import classes from "../../LoanDetails/loandetails.module.css";
import ModalForm from "./ModalForm";

const CoBorrowers = () => {
  const [loading, setLoading] = useState("fulfilled");
  const [show, setShow] = useState(false);
  const [title, setTitle] = useState("");

  function handleAdd() {
    setShow(true);
    setTitle("Add Coborrower");
  }

  function handleEdit() {
    setShow(true);
    setTitle("Edit Coborrower");
  }

  return (
    <div>
      <div className="text-end">
        <Button className="" text="Add Coborrower" onClick={handleAdd} />
      </div>
      <div style={{ overflowY: "scroll" }}>
        <CommonGrid
          className={`bg-white col-sm-12 mt-5 border border-2 ${classes.pastDue25} coborrowersTable`}
          title={"Co-Borrowers"}
          gridColumns={gridColumns_Coborrowers(handleEdit)}
          columnData={[]}
          status={loading}
        />
      </div>
      <ModalForm show={show} setShow={setShow} title={title} />
    </div>
  );
};

export default CoBorrowers;

const gridColumns_Coborrowers = (handleEdit) => {
  return [
    {
      field: "Edit",
      title: "Edit",
      Cell: (props) => {
        return (
          <button className="btn btn-primary text-white" onClick={handleEdit}>
            Edit
          </button>
        );
      },
    },
    { field: "Sortname", title: "Sortname" },
    { field: "Bylastname", title: "By Last Name" },
    { field: "Fullname", title: "Full Name" },
    { field: "Salutation", title: "Salutation" },
    { field: "firstname", title: "First Name" },
    { field: "mi", title: "Mi" },
    { field: "lastname", title: "Last Name" },
    { field: "street", title: "Street" },
    { field: "city", title: "City" },
    { field: "state", title: "State" },
    { field: "zipcode", title: "Zip Code" },
    { field: "phonehome", title: "Phone Home" },
    { field: "phonework", title: "Phone Work" },
    { field: "phonecell", title: "Phone Cell" },
    { field: "phonefax", title: "Phone Fax" },
    { field: "phonemain", title: "Phone Main" },
    { field: "tin", title: "TIN" },
    { field: "emailaddress", title: "Email Address" },
  ];
};
